import React from 'react';
import { graphql, useLazyLoadQuery, useRelayEnvironment } from 'react-relay';
import {
  NoAccountModalProvider,
  useFetchQuery,
} from '@sparknz/journeys-common';

import { ProductDetailsNoAccountModalProviderAccountListQuery } from '__generated__/ProductDetailsNoAccountModalProviderAccountListQuery.graphql';
import { useSegment } from 'shared/hooks';

type ProductDetailsNoAccountModalProviderProps = React.PropsWithChildren<{}>;

const accountListQuery = graphql`
  query ProductDetailsNoAccountModalProviderAccountListQuery {
    me {
      accountList {
        accountId
        segment
      }
    }
  }
`;

export default function ProductDetailsNoAccountModalProvider({
  children,
}: ProductDetailsNoAccountModalProviderProps) {
  const { segment } = useSegment();

  const relayEnvironment = useRelayEnvironment();
  const { fetch: fetchQuery } =
    useFetchQuery<ProductDetailsNoAccountModalProviderAccountListQuery>(
      accountListQuery,
      relayEnvironment,
    );
  const accountListResponse =
    useLazyLoadQuery<ProductDetailsNoAccountModalProviderAccountListQuery>(
      accountListQuery,
      {},
    );

  async function fetchAccountList() {
    const fetchAccountListResponse = await fetchQuery({});
    return fetchAccountListResponse.me.accountList;
  }

  return (
    <NoAccountModalProvider
      accountList={accountListResponse.me.accountList}
      fetchAccountList={fetchAccountList}
      segment={segment}
    >
      {children}
    </NoAccountModalProvider>
  );
}
